import { Auth } from 'aws-amplify';
import { call, put, select, takeLatest } from 'redux-saga/effects';

import {
  CHANGE_ACCOUNT_PASSWORD_SUBMIT,
  SEND_OTP
} from 'redux/sagas/actions/account';
import { LOADER_CLOSE, LOADER_OPEN } from 'redux/slices/app';
import { Toast } from '../../ui/components';
import i18next from 'i18next';
import { MODAL_CLOSE } from '../slices/modals';
import { SET_ACCESS_ERROR_OTP } from '../slices/authentication';
import { SIGNOUT } from './actions/authentication';
import { cognitoErrors } from '../../const';

function* sendOTP({ payload }) {
  try {
    yield put(LOADER_OPEN());
    // eslint-disable-next-line no-unused-vars
    const res = yield call([Auth, Auth.forgotPassword], payload);

    yield put({
      type: SEND_OTP._SUCCESS,
      payload
    });
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > account > SEND_OTP', err);
    if (err?.response?.status === 401) {
      yield put({ type: SIGNOUT._REQUEST });
    }
    yield put({
      type: SEND_OTP._ERROR,
      payload: err.message || 'Error on SEND_OTP'
    });
  } finally {
    yield put(LOADER_CLOSE());
  }
}

function* sendOTPWatch() {
  yield takeLatest(SEND_OTP._REQUEST, sendOTP);
}

function* changePasswordSubmit({ payload }) {
  try {
    yield put(LOADER_OPEN());
    const { code, password } = payload;
    const {
      accountInfo: { email }
    } = yield select(state => state.authentication);
    // eslint-disable-next-line no-unused-vars
    const res = yield call(
      [Auth, Auth.forgotPasswordSubmit],
      email,
      code,
      password
    );
    Toast.show(Toast.TYPE.SUCCESS, i18next.t('password_updated_success'));
    yield put({
      type: CHANGE_ACCOUNT_PASSWORD_SUBMIT._SUCCESS
    });
    yield put(MODAL_CLOSE());
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('sagas > chargers > CHANGE_ACCOUNT_PASSWORD_SUBMIT', err);
    if (err?.response?.status === 401) {
      yield put({ type: SIGNOUT._REQUEST });
    }
    const errorType = err.message.includes('code');
    yield put({
      type: CHANGE_ACCOUNT_PASSWORD_SUBMIT._ERROR,
      payload: {
        message: err.message,
        type: errorType ? 'code' : 'serviceResponse'
      }
    });
    yield put(SET_ACCESS_ERROR_OTP(cognitoErrors[err?.code]));
    Toast.show(Toast.TYPE.ERROR, i18next.t('change_password_error'));
  } finally {
    yield put(LOADER_CLOSE());
  }
}
function* changePasswordSubmitWatch() {
  yield takeLatest(
    CHANGE_ACCOUNT_PASSWORD_SUBMIT._REQUEST,
    changePasswordSubmit
  );
}

export default [sendOTPWatch(), changePasswordSubmitWatch()];
